<template>
  <ul :class="{ 'show-all': showAll }">
    <li
      v-for="item in items"
      :key="item.value"
      :class="{ active: item.isRefined }"
    >
      <a :href="createURL(getValue(item))" @click.prevent="() => onClick(item)">
        {{ item.label }} <span class="count-label">{{ item.count }}</span>
      </a>
      <hierarchical-menu-list
        v-if="item.data"
        :items="item.data"
        :refine="refine"
        :createURL="createURL"
        :class="subListClass"
        @onSelectItem="$emit('onSelectItem', $event)"
      />
    </li>
    <li v-if="showAll" class="button-less">
      <a @click.prevent="() => showLess()" href="#">{{
        gettext('Minder categorieën...')
      }}</a>
    </li>
    <li v-else class="button-more">
      <a @click.prevent="() => showMore()" href="#">{{
        gettext('Meer categorieën...')
      }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'HierarchicalMenuList',
  props: {
    items: Array,
    createURL: Function,
    refine: Function,
    subListClass: String,
  },
  data() {
    return {
      showAll: false,
    };
  },
  methods: {
    getValue(item) {
      // HACK:
      // By default clicking a refined item results in that filter/item being
      // removed as filter. More UX friendly is that if there is a child element
      // also selected, that clicking on the parent element makes the user go
      // back to the parent element (deselecting the child element)
      // The code below return the value of the child element if one is selected,
      // so that that filter is removed instead
      if (item.isRefined && item.data) {
        const refinedChildren = item.data.filter(d => d.isRefined);
        if (refinedChildren.length > 0) {
          return refinedChildren[0].value;
        }
      }
      return item.value;
    },
    onClick(item) {
      this.refine(this.getValue(item));
      this.$emit('onSelectItem', item);
    },
    showMore() {
      console.log('show more!');
      this.showAll = true;
    },
    showLess() {
      this.showAll = false;
      console.log('show less!');
    },
  },
};
</script>
